import { useId } from 'react';

// Aloha Amino brand mark — "Droplet" (concept #9): a water-drop circle
// with a cresting wave, drawn in the live brand blue (#0A84FF).
// Uses a per-instance clipPath id so the mark can render multiple times
// on one page (e.g. desktop + mobile nav) without id collisions.
export default function Logo({ className = 'h-7 w-7', title = 'Aloha Amino' }) {
  const clipId = useId();
  return (
    <svg
      className={`shrink-0 ${className}`}
      viewBox="0 0 100 100"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id={clipId}>
          <path d="M50 8 C70 32,82 44,82 60 a32 32 0 1 1 -64 0 C18 44,30 32,50 8 Z" />
        </clipPath>
      </defs>
      <path
        d="M50 8 C70 32,82 44,82 60 a32 32 0 1 1 -64 0 C18 44,30 32,50 8 Z"
        fill="#0A84FF"
      />
      <g
        clipPath={`url(#${clipId})`}
        fill="none"
        stroke="#fff"
        strokeWidth="5"
        strokeLinecap="round"
      >
        <path d="M14 62 C26 52,34 72,46 62 S70 52,90 62" />
      </g>
    </svg>
  );
}
